import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchActiveStories } from 'stores/auth';
import StoryViewer from './StoryViewer';
import './StoriesBar.scss';

function StoriesBar() {
  const { t } = useTranslation('translations', { useSuspense: false });
  const dispatch = useDispatch();
  const stories = useSelector((state) => state.auth.stories);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);

  useEffect(() => {
    dispatch(fetchActiveStories());
  }, [dispatch]);

  if (!stories || stories.length === 0) return null;

  const handleCircleClick = (index) => {
    setActiveGroupIndex(index);
    setViewerOpen(true);
  };

  const handleViewerClose = () => {
    setViewerOpen(false);
  };

  return (
    <section className="mb-3 stories-bar">
      <div className="stories-bar__list">
        {stories.map((group, index) => (
          <div
            key={group.id}
            className="stories-bar__item"
            onClick={() => handleCircleClick(index)}
          >
            <div className="stories-bar__circle">
              <img src={group.icon} alt={group.title} />
            </div>
            <span className="stories-bar__description">{group.description}</span>
          </div>
        ))}
      </div>
      {viewerOpen && (
        <StoryViewer
          stories={stories}
          initialGroupIndex={activeGroupIndex}
          onClose={handleViewerClose}
        />
      )}
    </section>
  );
}

export default StoriesBar;
